var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.8317 0.834301C16.9124 -0.084985 15.4196 -0.084985 14.5003 0.834301L9.09456 6.24002L3.68885 0.834301C2.76956 -0.084985 1.27671 -0.084985 0.357422 0.834301L7.38171 7.85859L0.357422 14.8829C1.27671 15.8022 2.76956 15.8022 3.68885 14.8829L9.09456 9.47716L14.5003 14.8829C15.4196 15.8022 16.9124 15.8022 17.8317 14.8829L10.8074 7.85859L17.8317 0.834301Z",
    fill: "#1C1E21"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/close-icon.b8a61b957f45029bebdd93d7aecdae02.svg";
export { ForwardRef as ReactComponent };